module.exports = __webpack_public_path__ + "static/media/queen-of-gold.13d702b7.gif";